import { create } from "zustand";

export interface Crumb {
	label: string;
	/** When set, the crumb renders as a Link; otherwise as plain text (use for the trailing/current crumb). */
	href?: string;
}

interface BreadcrumbState {
	/** Auto-generated from route path. */
	autoCrumbs: Crumb[];
	/** Manual overrides from useBreadcrumbs() hook. Takes priority when set. */
	overrideCrumbs: Crumb[];
	/** Computed crumbs: overrides if set, otherwise auto. */
	crumbs: Crumb[];

	setAutoCrumbs: (crumbs: Crumb[]) => void;
	setOverrideCrumbs: (crumbs: Crumb[]) => void;
	clearOverride: () => void;

	/** @deprecated Use setOverrideCrumbs or setAutoCrumbs. Kept for backward compat. */
	setCrumbs: (crumbs: Crumb[]) => void;
}

export const useBreadcrumbStore = create<BreadcrumbState>()((set) => ({
	autoCrumbs: [],
	overrideCrumbs: [],
	crumbs: [],

	setAutoCrumbs: (autoCrumbs) =>
		set((s) => ({
			autoCrumbs,
			crumbs: s.overrideCrumbs.length > 0 ? s.overrideCrumbs : autoCrumbs,
		})),

	setOverrideCrumbs: (overrideCrumbs) =>
		set((s) => ({
			overrideCrumbs,
			crumbs: overrideCrumbs.length > 0 ? overrideCrumbs : s.autoCrumbs,
		})),

	clearOverride: () =>
		set((s) => ({
			overrideCrumbs: [],
			crumbs: s.autoCrumbs,
		})),

	// Backward compat — maps to setOverrideCrumbs
	setCrumbs: (crumbs) =>
		set((s) => ({
			overrideCrumbs: crumbs,
			crumbs: crumbs.length > 0 ? crumbs : s.autoCrumbs,
		})),
}));
